import Link from 'gatsby-link';
import kebabCase from 'lodash/kebabCase';
import React from 'react';
import { Article, Content, Header, Layout, SectionTitle, SEO, Subline, Wrapper } from '../components';
import PageProps from '../models/PageProps';

export default class TagTemplate extends React.PureComponent<PageProps> {
  public render() {
    const { posts, tagName } = this.props.pathContext;
    const totalCount = posts ? posts.length : 0;
    const subline = `${totalCount} post${totalCount === 1 ? '' : 's'} tagged with "${tagName}"`;

    return (
      <Layout>
        <SEO isPost={false} titlePrefix={`${'Tags'} | `}/>
        <Header>
          <SectionTitle>Tag &ndash; {tagName}</SectionTitle>
          <Subline sectionTitle light={true}>
            {subline} (See <Link to='/tags'>all tags</Link>)
          </Subline>
        </Header>
        <Wrapper>
          <Content>
            {posts
              ? posts.map((post: any, index) => (
                <Article
                  title={post.frontmatter.title}
                  date={post.frontmatter.date}
                  excerpt={post.excerpt}
                  slug={kebabCase(post.frontmatter.title)}
                  timeToRead={post.timeToRead}
                  category={post.frontmatter.category}
                  key={index}
                />
              ))
              : null}
          </Content>
        </Wrapper>
      </Layout>
    );
  }
}
